import { memo } from "react";

import type { RequestFilterType } from "../../../types/filters";

import { openTableConfig } from "../../../config/tables/superadmin/openTableConfig";
import { UnifiedSuperAdminTab } from "./UnifiedSuperAdminTab";

interface OpenTabProps {
  lazyLoadingConfig?: {
    currentTab: string;
    enabled: boolean;
  };
  searchValue?: string;
  selectedFilter?: RequestFilterType;
}

function OpenTabComponent(props: OpenTabProps) {
  return (
    <UnifiedSuperAdminTab
      {...props}
      tableConfig={openTableConfig}
      tabType="open"
    />
  );
}

export const OpenTab = memo(OpenTabComponent);
